import React from "react";

import {
  Box,
  Flex,
  Text,
  Avatar,
  Progress,
  Icon,
  Input,
} from "@chakra-ui/react";
import { FaComment, FaHeart, FaPaperPlane } from "react-icons/fa";

interface InstagramStoryOverlayProps {
  profileUrl: string;
  username: string;
  timestamp: string;
  isFallback: boolean;
}

export default function InstagramStoryOverlay({ profileUrl, username, timestamp, isFallback }: InstagramStoryOverlayProps) {
  return (
    <Flex
      position="absolute"
      inset="0"
      direction="column"
      justify="space-between"
    >
      {/* Top Section with Progress and Profile */}
      <Box p={4} pt={isFallback ? 8 : 4}>
        <Flex gap={2}>
          <Progress
            size="xs"
            value={100}
            sx={{
              "& > div": {
                background: "white",
              },
            }}
            isAnimated
            borderRadius="full"
            flex="1"
            bg="whiteAlpha.500"
          />
          <Progress
            size="xs"
            value={50}
            sx={{
              "& > div": {
                background: "white",
              },
            }}
            isAnimated
            borderRadius="full"
            flex="1"
            bg="whiteAlpha.500"
          />
          <Progress
            size="xs"
            value={0}
            sx={{
              "& > div": {
                background: "white",
              },
            }}
            isAnimated
            borderRadius="full"
            flex="1"
            bg="whiteAlpha.500"
          />
        </Flex>

        <Flex align="center" gap={3} mt={2}>
          <Avatar size="xs" src={profileUrl} border="2px solid white" />
          <Flex direction="row" align="center" gap={2}>
            <Text fontWeight="bold" fontSize="sm" color="white">
              {username}
            </Text>
            <Text fontSize="xs" color="white" opacity="0.8">
              {timestamp}
            </Text>
          </Flex>
        </Flex>
      </Box>

      {/* Bottom Controls */}
      <Box>
        <Flex align="center" gap={4} bg="black" p={4}>
          <Input
            placeholder="Send message..."
            borderRadius="full"
            bg="rgba(255, 255, 255, 0.2)"
            color="white"
            _placeholder={{ color: "gray.300" }}
            border="none"
            size="sm"
            _focus={{ boxShadow: "none" }}
          />
          <Flex
            justify="flex-end"
            align="center"
            gap={3}
            color="white"
            fontSize="lg"
          >
            <Icon as={FaHeart} />
            <Icon as={FaComment} />
            <Icon as={FaPaperPlane} />
          </Flex>
        </Flex>
      </Box>
    </Flex>
  )
}